export enum COMPANY_STATUS {
  new = 0,
  published,
  archived
}

export enum COMPANY_STATUS_TRANSITION_TYPE {
  publish = 'publish',
  unpublish = 'unpublish',
  archive = 'archive',
  reopen = 'reopen'
}

export const PROFILE_CATEGORY = {
  grower: 'grower',
  supplier: 'supplier',
  buyer: 'buyer'
}
